import * as React from "react"

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip"

/**
 * Hover explanation for a number.
 *
 * The report lenses lean on these: a bare "—" or a stacked bar needs to say
 * what it stands for, and a cell has no room to. Base UI's trigger composes
 * through `render` (not `asChild`), so this wraps that one awkwardness in a
 * single place — pass `render` to keep the element you already had, e.g. an
 * SVG `<circle>` or the bar `<div>`.
 */
export function Hint({
  label,
  render,
  children,
}: {
  label: React.ReactNode
  render?: React.ReactElement<Record<string, unknown>>
  children?: React.ReactNode
}) {
  return (
    <TooltipProvider delay={150}>
      <Tooltip>
        <TooltipTrigger render={render ?? <span className="cursor-default" />}>
          {children}
        </TooltipTrigger>
        <TooltipContent>{label}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
